import { queryFor } from "@visioni/a3s-client-api/app";
import { getAlarmConfigurationEndpoint, getScheduleHistoryEndpoint } from "../client-messages/alarms";

/**
 * React Query options factory for the alarm configuration of a camera.
 * Usage: `alarmConfigurationQuery(apiConfig, pathParams)` inside `useQuery(...)`.
 */
export const alarmConfigurationQuery = queryFor(getAlarmConfigurationEndpoint);

/**
 * React Query options factory for the schedule history of a camera.
 * Usage: `alarmScheduleHistoryQuery(apiConfig, pathParams, { from, to })` inside `useQuery(...)`.
 */
export const alarmScheduleHistoryQuery = queryFor(getScheduleHistoryEndpoint);
